import { type Dispatch, type SetStateAction, useEffect } from 'react'
import type { TextLinkingSession } from '../types/text-linking-session'

/**
 * Tool changes that end text-linking UI: a shape or pen tool cancels an in-progress link, and
 * leaving the Text Tool (or starting a link) clears its hover "+".
 */
export function useTextLinkingToolResets({
  isInShapeCreationMode,
  isInPenToolMode,
  isInTextCreationMode,
  isTextLinkingActive,
  setTextLinking,
  setTextToolHoverFrameId,
}: {
  isInShapeCreationMode: boolean
  isInPenToolMode: boolean
  isInTextCreationMode: boolean
  isTextLinkingActive: boolean
  setTextLinking: Dispatch<SetStateAction<TextLinkingSession | null>>
  setTextToolHoverFrameId: Dispatch<SetStateAction<string | null>>
}) {
  // Cancel in-progress text linking on tool change away from select/type.
  useEffect(() => {
    if (isInShapeCreationMode || isInPenToolMode) {
      setTextLinking(null)
    }
  }, [isInShapeCreationMode, isInPenToolMode, setTextLinking])

  // Clear the Text Tool hover "+" once linking starts (the full ports-on-all-frames rendering
  // takes over) or the Text Tool is no longer active.
  useEffect(() => {
    if (!isInTextCreationMode || isTextLinkingActive) {
      setTextToolHoverFrameId(null)
    }
  }, [isInTextCreationMode, isTextLinkingActive, setTextToolHoverFrameId])
}
